<a [routerLink]="['/product', product._id]" *ngIf="product" class="product-display-icon" placement="right" container="body" [ngbTooltip]="product.title">
	<img [src]="product.variants.length && product.variants[0].media.length ? product.variants[0].media[0].urlSmall : '../../../assets/images/image-placeholder.png'">
</a>
